import { create } from 'zustand';
import { JobPost } from '@/types/jobPost.types';
import { v4 as uuidv4 } from 'uuid';

interface JobPostsState {
  jobPosts: JobPost[];
  addJobPost: (jobPost: Omit<JobPost, 'id' | 'createdAt' | 'updatedAt'>) => void;
  updateJobPost: (jobPost: JobPost) => void;
  deleteJobPost: (id: string) => void;
}

export const useJobPostsStore = create<JobPostsState>((set) => ({
  jobPosts: [],
  addJobPost: (jobPost) => {
    const now = new Date().toISOString();
    const newJobPost: JobPost = {
      ...jobPost,
      id: uuidv4(),
      createdAt: now,
      updatedAt: now,
    };
    set((state) => ({
      jobPosts: [...state.jobPosts, newJobPost],
    }));
  },
  updateJobPost: (jobPost) => {
    set((state) => ({
      jobPosts: state.jobPosts.map((post) =>
        post.id === jobPost.id
          ? { ...jobPost, updatedAt: new Date().toISOString() }
          : post
      ),
    }));
  },
  deleteJobPost: (id) => {
    set((state) => ({
      jobPosts: state.jobPosts.filter((post) => post.id !== id),
    }));
  },
}));
